import { BehaviorSubject } from '../../core/observer/BehaviorSubject';

export const gamePadLocaleState = {
  autoSpinButtonActive: new BehaviorSubject(false),
  betButtonActive: new BehaviorSubject(false),
};
